import React, { Fragment} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import s from './ModelVariantConfigurationTabs.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { useParams } from 'react-router-dom';


const Tab = ({ selectedPage, pageComponent, url, title }) => (
  <Fragment>
    <Link className={classNames({ [s.active]: selectedPage === pageComponent })} to={url}>
      {title}
      {selectedPage === pageComponent && <span />}
    </Link>
  </Fragment>
);

const ModelVariantConfigurationTabs = ({ selectedPage, userProfileWidgets }) => {
    let { ModelCategoryId, ModelId, ModelVariantId } = useParams();

  return (
    <ul className={s.tabNav}>
     
      {IsWidgetAccessible(userProfileWidgets, 'MODELVARIANT_UNIT_VIEW') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant-configuration/${ModelVariantId}/model-variant-units-list`}
            title={<FormattedMessage id="modelVariantTabs.manageModelVariantUnits" defaultMessage="Manage Model Variant Units" />}
            selectedPage={selectedPage}
            pageComponent="manageModelVariantUnits"
          />
        </li>
      )}
       {IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTSETPOINTS') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant-configuration/${ModelVariantId}/model-variant-setpoints-list`}
            title={<FormattedMessage id="modelVariantTabs.modelVariantSetpoints" defaultMessage="Model Variants Setpoints" />}
            selectedPage={selectedPage}
            pageComponent="manageModelVariantsSetpoints"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTTHRESHOLDS') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant-configuration/${ModelVariantId}/model-variant-thresholds-list`}
            title={<FormattedMessage id="modelVariantTabs.modelVariantThresholds" defaultMessage="Model Variants Thresholds" />}
            selectedPage={selectedPage}
            pageComponent="manageModelVariantThresholds"
          />
        </li>
      )}
    </ul>
  )
};

ModelVariantConfigurationTabs.propTypes = {
  selectedPage: PropTypes.string.isRequired
};

export default ModelVariantConfigurationTabs;
